export const IMPORT_FIELDS = [
  {
    key: "first_name",
    label: "First Name",
    aliases: ["firstname", "first", "forename", "given name", "fname", "f name"],
  },
  {
    key: "middle_name",
    label: "Middle Name",
    aliases: ["middlename", "middle", "mname", "m name"],
  },
  {
    key: "last_name",
    label: "Last Name",
    aliases: ["lastname", "last", "surname", "family name", "lname", "l name"],
  },
  {
    key: "date_of_birth",
    label: "Date of Birth",
    aliases: ["dob", "birth date", "birthdate"],
  },
  { key: "gender", label: "Gender", aliases: ["sex"] },
  {
    key: "clockin_pin",
    label: "Clock-in PIN",
    aliases: ["pin", "clock in pin"],
  },
  {
    key: "payroll_id",
    label: "Payroll ID",
    aliases: ["payroll", "payroll no", "payroll id", "payroll number"],
  },
  {
    key: "personal_email",
    label: "Personal Email",
    aliases: [
      "personal email",
      "email",
      "home email",
      "work email",
      "company email",
    ],
  },
  {
    key: "personal_contact_number",
    label: "Personal Contact Number",
    aliases: ["personal mobile", "personal mobile number", "mobile", "cell"],
  },
  {
    key: "work_phone",
    label: "Work Phone",
    aliases: ["work mobile", "work mobile number", "work phone"],
  },
  {
    key: "start_date",
    label: "Start Date",
    aliases: ["start date", "employment start", "joined"],
  },
  {
    key: "probation_ends_on",
    label: "Probation End Date",
    aliases: [
      "probation",
      "probation end",
      "probation end date",
      "probation ends on",
      "probation date",
    ],
  },
  {
    key: "NI_number",
    label: "NI Number",
    aliases: ["ni number", "ni", "nino"],
  },
  {
    key: "accounting_type",
    label: "Accounting Type",
    aliases: [
      "accounting type",
      "account type",
      "user type",
      "staff type",
      "access level",
    ],
  },
  {
    key: "employment_type",
    label: "Employment Type",
    aliases: ["employment type", "contract"],
  },
  {
    key: "default_location_id",
    label: "Default Location",
    aliases: ["default location", "location", "home"],
  },
  {
    key: "work_location",
    label: "Working Locations",
    aliases: [
      "working locations",
      "additional worked locations",
      "other locations",
      "also works at",
    ],
  },
  {
    key: "default_role",
    label: "Default Role",
    aliases: ["default role", "role", "job title", "position"],
  },
  {
    key: "assigned_role",
    label: "Working Roles",
    aliases: [
      "working roles",
      "working role",
      "other roles worked",
      "other roles",
    ],
  },
  {
    key: "weekly_hours",
    label: "Contracted Weekly Hours",
    aliases: ["contracted hours", "contracted weekly hour", "weekly hours"],
  },
  {
    key: "wage_amount",
    label: "Wage Amount",
    aliases: ["hourly rate", "wage", "wage amount", "pay rate"],
  },
  {
    key: "overtime_rate_per_hour",
    label: "Overtime Rate Per Hour",
    aliases: ["overtime rate", "ot rate"],
  },
  {
    key: "happy_to_nights",
    label: "Happy to work nights?",
    aliases: ["happy to do nights", "happy to nights", "nights"],
  },
  {
    key: "holiday_allocation",
    label: "Holiday Type",
    aliases: ["holiday type", "holiday allocation"],
  },
  {
    key: "holiday_percentage",
    label: "Accrual Percentage",
    aliases: ["accrual percentage", "accrual %", "accrual"],
  },
  {
    key: "type",
    label: "Allocation Type",
    aliases: [
      "allocation type",
      "annual leave allocation type",
      "al allocation",
      "al type",
      "entitlement type",
    ],
  },
  { key: "nmc_pin", label: "NMC PIN", aliases: ["nmc pin", "nmc"] },
  {
    key: "nmc_renewal_date",
    label: "NMC Renewal Date",
    aliases: ["nmc renewal date", "nmc expiry"],
  },
];

export const FIELD_BY_KEY = IMPORT_FIELDS.reduce((acc, f) => {
  acc[f.key] = f;
  return acc;
}, {});

export const IMPORT_MODULE_EMPLOYEE = "employee";
export const IMPORT_MODULE_USER = "user";

export const USER_IMPORT_KEYS = [
  "first_name",
  "middle_name",
  "last_name",
  "date_of_birth",
  "gender",
  "personal_email",
  "work_phone",
  "start_date",
  "probation_ends_on",
  "accounting_type",
  "default_role",
  "default_location_id",
];

export const USER_FIELD_LABELS = {
  personal_email: "Work Email Address",
  work_phone: "Phone",
  date_of_birth: "Date Of Birth",
  accounting_type: "Account Type",
};

export const EMAIL_RE =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

// Required by the Quick Add employee form, so required here too.
// Mirrors EmployeeImportFieldCatalog::REQUIRED_KEYS.
export const KEY_FIELDS = [
  "first_name",
  "last_name",
  "personal_email",
  "accounting_type",
  "default_role",
  "default_location_id",
  "start_date",
];

export const normalizeImportModule = (module) =>
  module === IMPORT_MODULE_USER
    ? IMPORT_MODULE_USER
    : IMPORT_MODULE_EMPLOYEE;

export const fieldsForModule = (module) => {
  if (normalizeImportModule(module) !== IMPORT_MODULE_USER) {
    return IMPORT_FIELDS.filter((field) => field.key !== "probation_ends_on");
  }
  return USER_IMPORT_KEYS.map((key) => {
    const field = FIELD_BY_KEY[key];
    if (!field) return null;
    return {
      ...field,
      label: USER_FIELD_LABELS[key] || field.label,
    };
  }).filter(Boolean);
};

export const keyFieldsForModule = (module) => {
  normalizeImportModule(module);
  return KEY_FIELDS;
};

export const fieldByKeyForModule = (module) =>
  fieldsForModule(module).reduce((acc, field) => {
    acc[field.key] = field;
    return acc;
  }, {});

export const DATE_FIELDS = {
  date_of_birth: true,
  start_date: true,
  nmc_renewal_date: true,
  probation_ends_on: true,
};

export const EMP_TYPES = [
  "full time",
  "part time",
  "fixed term",
  "casual",
  "apprentice/trainee",
  "agency",
  "contractor/freelancer",
  "temporary",
];

export const EMP_SYN = {
  ft: "full time",
  "f/t": "full time",
  "full-time": "full time",
  fulltime: "full time",
  perm: "full time",
  permanent: "full time",
  pt: "part time",
  "p/t": "part time",
  "part-time": "part time",
  parttime: "part time",
  bank: "casual",
  "zero hours": "casual",
  "0 hours": "casual",
  temp: "temporary",
};

export const GENDER_SYN = {
  m: "male",
  f: "female",
  male: "male",
  female: "female",
  man: "male",
  woman: "female",
  x: "prefer not to say",
  other: "prefer not to say",
  "not specified": "prefer not to say",
  unspecified: "prefer not to say",
  "prefer not to say": "prefer not to say",
};

// Values the employee screens accept. Mirrors EmployeeImportFieldCatalog::ALLOWED_VALUES.
export const GENDERS = ["Male", "Female", "Prefer not to say"];
export const AL_TYPES = ["Days", "Hours"];
export const HOLIDAY_TYPES = ["accure holiday", "fixed allowance"];
export const ACCOUNTING_TYPES = ["employee", "manager", "administrator"];

// Fields holding several company records, pipe-separated.
export const MULTI_VALUE_KEYS = {
  work_location: "location",
  assigned_role: "role",
};

// Fields whose value must be one of a fixed list.
export const ENUM_OPTIONS = {
  accounting_type: ACCOUNTING_TYPES,
  gender: GENDERS,
  employment_type: EMP_TYPES,
  holiday_allocation: HOLIDAY_TYPES,
  type: AL_TYPES,
  happy_to_nights: ["Y", "N"],
};

export const HOL_SYN = {
  accrual: "accure holiday",
  accrue: "accure holiday",
  accrued: "accure holiday",
  fixed: "fixed allowance",
  allowance: "fixed allowance",
};

export const YN_SYN = {
  y: "Y",
  yes: "Y",
  true: "Y",
  1: "Y",
  n: "N",
  no: "N",
  false: "N",
  0: "N",
};
